import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import { EventContext, useEventContext } from 'context/EventContext'
import HomeButton from 'screens/home/components/HomeButton'

import HomeHeading from '../HomeHeading'
import CategoryItem from './components/CategoryItem'

import classes from './SoftwareCategories.module.scss'

const SLUG_TO_ICON = {
  crm: ['ic', 'crm'],
  'marketing-automation': ['ga', 'megaphone'],
  'email-marketing': ['ga', 'email'],
  'business-intelligence': ['ga', 'lightbulb'],
  'social-media': ['ga', 'social', 'media'],
  survey: ['ga', 'report'],
  'data-visualization': ['ga', 'data', 'vis'],
  'data-analysis': ['ga', 'analysis'],
  'content-marketing': ['ga', 'content'],
  'lead-generation': ['ga', 'leads'],
  'customer-loyalty': ['ga', 'customer', 'loyalty'],
  'web-analytics': ['ga', 'web', 'analytics'],
  'project-management': ['ic', 'project', 'management'],
  'inventory-management': ['ic', 'inventory', 'management'],
  scheduling: ['ic', 'scheduling'],
  'appointments-scheduling': ['ga', 'schedule', 'calendar'],
  'human-resources': ['ic', 'human', 'resources'],
  'billing-invoicing': ['ga', 'billing'],
  'time-tracking': ['ic', 'time', 'tracking'],
  accounting: ['ic', 'accounting'],
  'task-management': ['ga', 'tasks'],
  'applicant-tracking': ['ic', 'applicant', 'tracking'],
  'field-service-management': ['ic', 'field', 'service', 'management'],
  'membership-management': ['ic', 'membership', 'management'],
  'time-clock-attendance': ['ga', 'clock'],
  'help-desk-ticketing': ['ic', 'call', 'center'],
  'reservation-online-booking': ['ga', 'reservation'],
  'construction-management': ['ic', 'construction', 'estimating'],
  'live-chat': ['ic', 'live', 'chat'],
  'warehouse-management': ['ic', 'warehouse', 'management'],
}
const CATEGORIES_PER_ROW = 10

const toRelativeUrl = url => {
  try {
    if (!url) return ''
    return url.startsWith('http') ? new URL(url).pathname : url
  } catch {
    return ''
  }
}

const groupCategories = categories => {
  const groups = []
  for (let i = 0; i < categories.length; i += CATEGORIES_PER_ROW) {
    groups.push(categories.slice(i, i + CATEGORIES_PER_ROW))
  }
  return groups
}

const SoftwareCategories = ({ categories = [] }) => {
  const { addEvent } = useEventContext()

  const categoryGroups = groupCategories(
    categories.map(({ name, slug, url }) => ({
      id: slug,
      title: name,
      url: toRelativeUrl(url),
      icon: SLUG_TO_ICON[slug],
    }))
  )

  return (
    <div className={clsx('SoftwareCategories', classes.root)}>
      <Container>
        <HomeHeading>Software Categories</HomeHeading>
        <EventContext
          value={{
            engagementComponent: 'related-categories',
            engagementDestination: 'go-to_category_all-products',
            engagementDetails: 'list-item_category',
            name: 'engagement_facet_click',
          }}
        >
          {categoryGroups.map(group => (
            <div className={classes.categoryGroup} key={`group-${group[0].id}`}>
              {group.map(category => (
                <CategoryItem key={category.id} category={category} titleSuffix="Software" />
              ))}
            </div>
          ))}
        </EventContext>
        <div className={classes.ctaContainer}>
          <HomeButton
            href="/browse/"
            data-testid="software-categories-browse"
            {...addEvent({
              engagementComponent: 'related-categories',
              engagementDestination: 'go-to_software-categories',
              engagementDetails: 'button_browse',
              name: 'engagement_facet_click',
            })}
          >
            See all categories
          </HomeButton>
        </div>
      </Container>
    </div>
  )
}

export default SoftwareCategories
